<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author"><br/><br/><br/><br/><br/>
<h1>About the Author</h1><br/><br/>
<p>Azzedine Kechroud was born on 11 February 1946 in Algiers, Algeria. He has a degree in private law. He is a writer, novelist and poet. He started writing when he was young but began publishing later. He lives in England as a British citizen with his family and grandsons. He is retired.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?f6879948